import React, { useMemo, useState } from "react";
import FinancialServiceCard from "./FinancialServiceCard";
import { useNavigate } from "react-router-dom";

export default function FinancialServiceTabs() {
  const [activeTab, setActiveTab] = useState("Transferts");
  const navigate = useNavigate();

  const services = useMemo(
    () => [
      {
        title: "Direct Money",
        subtitle: "Transfert rapide Canada-Afrique",
        icon: "✈️",
        tab: "Transferts",
        link: "/transaction",
      },
      {
        title: "Recharge Compte",
        subtitle: "Orange Money, MTN Mobile, etc.",
        icon: "➕",
        tab: "Réapprovisionnements",
        link: "/wallet",
      },
      {
        title: "Prêt Personnel",
        subtitle: "Disponible uniquement au Canada",
        icon: "💳",
        tab: "Prêts",
        link: "/schedule-transfer",
      },
    ],
    []
  );

  const tabs = ["Transferts", "Réapprovisionnements", "Prêts"];

  return (
    <section
      className="rounded-2xl border border-black/5 dark:border-white/10
                 bg-white dark:bg-slate-900 shadow-sm p-5"
    >
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="text-base font-semibold text-slate-900 dark:text-white">
            Services financiers
          </h2>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            Accédez rapidement à ce dont vous avez besoin
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div
        className="mt-4 inline-flex rounded-2xl border border-black/5 dark:border-white/10
                   bg-slate-50 dark:bg-white/5 p-1"
      >
        {tabs.map((label) => (
          <TabButton
            key={label}
            label={label}
            active={activeTab === label}
            onClick={() => setActiveTab(label)}
          />
        ))}
      </div>

      {/* Cards */}
      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {services
          .filter((s) => s.tab === activeTab)
          .map((service) => (
            <FinancialServiceCard
              key={service.title}
              title={service.title}
              subtitle={service.subtitle}
              icon={service.icon}
              onClick={() => navigate(service.link)}
            />
          ))}
      </div>
    </section>
  );
}

function TabButton({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 rounded-xl text-sm font-medium transition
        ${
          active
            ? "bg-slate-900 text-white dark:bg-white dark:text-slate-900 shadow-sm"
            : "text-slate-600 dark:text-slate-200 hover:bg-black/5 dark:hover:bg-white/10"
        }`}
    >
      {label}
    </button>
  );
}
